import React, { useState } from "react";
import { config } from "../config";
import "./category.css";
import { useNavigate } from "react-router-dom";

const Category = () => {
  const [popupVisible, setPopupVisible] = useState(false);
  const [viewAllPopupVisible, setViewAllPopupVisible] = useState(false);
  const [popupaskque, setpopupaskque] = useState(false);
  const [buttonTexts, setButtonTexts] = useState([]);
  const [clickedImage, setClickedImage] = useState(null);

  const [textLine1, setTextLine1] = useState("");
  const [textLine2, setTextLine2] = useState("");
  const [TopicValue, setTopicValue] = useState("");
  const navigate = useNavigate();

  const handleButtonClick = (text, category) => {
    navigate("/ai-assistant", { state: { text, category } });
  };
  React.useEffect(() => {
    document.documentElement.style.setProperty("--main-color", config.color);
  }, [config.color]);


  const handleImageClick = (imageId) => {
    setClickedImage(imageId);
    setPopupVisible(true);

    const categoryData = {
      button1: {
        text: [
          "Do I Have a Valid Personal Injury Case?",
          "How do I prove that someone else is liable for my injuries?",
          "What factors determine the value of my personal injury claim?",
          "Can I recover lost wages and future earnings?",
          "Impact of social media on mental health and public opinion",
        ],
        title: "Personal Injury",
      },
      button2: {
        text: [
          "How Are Assets and Debts Divided in a Divorce?",
          "What Is Alimony and Will I Have to Pay or Receive It?",
          "What are the steps to file for divorce?",
          "Do I need a lawyer to file for divorce, or can I do it myself?",
        ],
        title: "Family Law",
      },
      button3: {
        text: [
          "What are my rights if I’m arrested by the police?",
          "Do I Need a Criminal Defense Lawyer?",
          "Can I represent myself in a criminal case, and is it advisable?",
          "What distinguishes a misdemeanour from a felony?",
        ],
        title: "Criminal Law",
      },
      button4: {
        text: [
          "What Are My Rights If I’m Wrongfully Terminated?",
          "How Do I Handle Workplace Discrimination or Harassment?",
          "Am I Entitled to Overtime Pay?",
          "What distinguishes a misdemeanour from a felony?",
        ],
        title: "Employment Law",
      },
      button5: {
        text: [
          "How do I ensure the property has clear title and no outstanding liens?",
          "What are the common pitfalls to avoid during a real estate transaction?",
          "How Do I Handle Disputes with Neighbors or Property Boundaries?",
          "What Are My Rights and Responsibilities as a Landlord or Tenant?",
        ],
        title: "Real Estate Law",
      },
      button6: {
        text: [
          "What Documents Do I Need for a Comprehensive Estate Plan?",
          " How Can I Minimize Estate Taxes and Avoid Probate?",
          "What Happens If I Die Without a Will?",
          "How will my assets be distributed if I don’t have a will in place?",
          "What Is the Probate Process, and How Long Does It Take?",
        ],
        title: "Estate Planning and Probate",
      },
      button7: {
        text: [
          "How Can I Obtain a Visa or Green Card?",
          "What Should I Do If My Visa Is About to Expire?",
          "What Should I Do If I’m Facing Deportation?",
          "What are my rights if I’m detained by immigration authorities?",
          "How long does it take to get a visa or green card, and what are the costs involved?",
          "How Can I Bring My Family to the USA?",
          "What is the process for naturalization, and how long does it take?",
        ],
        title: "Immigration Law",
      },
      button8: {
        text: [
          "How Do I Deal with Unfair Debt Collection Practices?",
          "What Are My Options If I’m Sold a Defective Product?",
          "How do I file a complaint with consumer protection agencies, like the Better Business Bureau (BBB) or the Consumer Financial Protection Bureau (CFPB)?",
          "What Are My Rights as a Consumer?",
          "What Should I Do If I’ve Been a Victim of Fraud or Scams?",
          "What protections do I have against faulty or defective products?",
        ],
        title: "Consumer Protection",
      },
      button9: {
        text: [
          "How Do Environmental Regulations Affect My Business?",
          "What are the potential penalties for non-compliance with environmental laws?",
          "What Should I Do If My Business Is Facing an Environmental Investigation or Enforcement Action?",
          "What Are the Legal Requirements for Environmental Impact Assessments (EIA)?",
          "Can I Be Held Liable for Environmental Damage Caused by Previous Property Owners?",
        ],
        title: "Environmental Law",
      },
      button10: {
        text: [
          "How Can I Protect My Intellectual Property?",
          "How do I determine which type of protection is appropriate for my creation?",
          "What Should I Do If Someone Is Infringing on My Intellectual Property?",
          "How Do I Avoid Infringing on Others’ Intellectual Property?",
          "What Are the International Considerations for Intellectual Property?",
          "What is the process for registering a patent, trademark, or copyright?",
        ],
        title: " Intellectual Property Law",
      },
      button11: {
        text: [
          "How Can I Minimize My Tax Liability?",
          "Can I Settle My Tax Debt with the IRS?",
          "Are there legal tax shelters or strategies I should consider?",
          "What Should I Do If I Receive a Notice from the IRS?",
          "What Are the International Considerations for Intellectual Property?",
          "What Are the Tax Implications of Selling or Transferring Property?",
          "How Do I Handle Tax Issues Related to My Business?",
        ],
        title: "Tax Law",
      },
    };

    if (categoryData[imageId]) {
      setButtonTexts(categoryData[imageId].text);
      setTextLine1(categoryData[imageId].title);
      setTextLine2("Please select a question to continue.");
    }
  };

  const handleAskQueClick = () => {
    setpopupaskque(true);
    setViewAllPopupVisible(false);
    setPopupVisible(false);
  };

  const closePopup = () => setPopupVisible(false);
  const closeViewAllPopup = () => setViewAllPopupVisible(false);
  const closepopupaskque = () => setpopupaskque(false);
  return (
    <div className="category_background">
      <div className="category_top">
        <div className="category_top_title">Ask about</div>
        <div className="view_all" onClick={() => setViewAllPopupVisible(true)}>
          View All
        </div>
      </div>

      <div className="category_cards">
        {[...Array(11)].map((_, i) => (
          <img
            key={i}
            className="card_button"
            src={config[`ask_button${i + 1}`]}
            alt="ask_about"
            onClick={() => handleImageClick(`button${i + 1}`)}
          />
        ))}
      </div>

      {popupVisible && (
        <div className="popup_askabout">
          <div className="popup_content_askabout">
            <div className="popup_header_askabout">
              <span>Ask About</span>
              <button className="close_button_askabout" onClick={closePopup}>
                <img src={config.close_button_x} alt="close" />
              </button>
            </div>
            <div className="popup_text_askabout">
              <div>{textLine1}</div>
              <p>{textLine2}</p>
            </div>
            <div className="popup_buttons_askabout">
              {buttonTexts.map((text, index) => (
                <button
                  key={index}
                  className="popup_button_askabout"
                  onClick={() => handleButtonClick(text, textLine1)}
                >
                  {text}
                </button>
              ))}
            </div>
            <div className="bottom_buttons_askabout">
              or{" "}
              <button
                className="askyourquestion"
                onClick={() => handleAskQueClick()}
              >
                Ask Your Own Question
              </button>
            </div>
          </div>
        </div>
      )}

      {viewAllPopupVisible && (
        <div className="popup_viewall">
          <div className="popup_content_viewall">
            <div className="popup_header_viewall">
              <span>All Categories</span>
              <button
                className="close_button_viewall"
                onClick={closeViewAllPopup}
              >
                <img src={config.close_button_x} alt="close" />
              </button>
            </div>
            <div className="popup_images_viewall">
              {[...Array(11)].map((_, i) => (
                <img
                  key={i}
                  className="popup_card_button"
                  src={config[`ask_button${i + 1}`]}
                  alt=""
                  onClick={() => {
                    handleImageClick(`button${i + 1}`);
                    closeViewAllPopup();
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      {popupaskque && (
        <div className="popup_askabout">
          <div className="popup_content_askabout">
            <div className="popup_header_askabout">
              <span>Ask About</span>
              <button
                className="close_button_askabout"
                onClick={closepopupaskque}
              >
                <img src={config.close_button_x} alt="close" />
              </button>
            </div>
            <div className="popup_text_askabout">
              <div>Askyour own question</div>
            </div>

            <textarea
              className="Topic_askabout"
              id=""
              placeholder="Type your text here...."
              value={TopicValue}
              name="Topic"
              onChange={(e) => setTopicValue(e.target.value)}
              maxLength={1000}
            >
              {" "}
            </textarea>
            <div className="bottom_buttons_askabout">
              <button
                className="askyourquestion"
                onClick={() => handleButtonClick(TopicValue)}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Category;
